export function notEmpty( value ) {
	return !value && 'Please enter a value';
}

export function notEmptyCustom( message = 'Please enter a value' ) {
	return function( value ) {
		return !value && message;
	};
}

export function minLength( minimumLength ) {
	return function( value ) {
		return (
			value.length <= minimumLength &&
			`Please enter more than ${minimumLength} characters`
		);
	};
}

export function postcode( value ) {
	return value.match( /^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}|GIR ?0A{2})$/i ) ?
		true :
		'Please enter a valid postcode';
}

// No need for anything more complex than this
export function email( value ) {
	return value.match( /.+@.+\..{2}/i ) ?
		true :
		'Please enter a valid email';
}
